import React from 'react';
import {
  Button,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText,
} from '@mui/material';
import T from '../atoms/Typo';

const SimpleDeleteConfirm = ({
  onDelete,
  onCancel,
  confirm = 'Delete',
  header = null,
  message = null,
}: any) => {
  if (typeof onDelete !== 'function') {
    return null;
  }

  return (
    <Dialog open={true} onClose={onCancel}>
      <DialogTitle>{T.header(header ?? 'Confirm Delete')}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {message ?? 'Data will be lost. This action cannot be undone.'}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} color="primary">
          Cancel
        </Button>
        <Button onClick={onDelete} color="secondary" variant="contained">
          {confirm}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SimpleDeleteConfirm;
